import { createSlice } from "@reduxjs/toolkit";

const schoolsSlice = createSlice({
  name: "schools",
  initialState: {
    schoolsArray:[]
  },
  reducers: {
    getSchools: (state, action) => {
  state.schoolsArray =action.payload;
 },
 },
});

export const { getSchools } = schoolsSlice.actions;
export default schoolsSlice.reducer;